/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import UserModel from 'uplisting-frontend/models/user';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IArgs {}

interface PopoverSettingsMenuSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiPopoverSettingsMenu extends Component<PopoverSettingsMenuSignature> {
  @service session!: Services['session'];

  @cached
  get currentUser(): UserModel {
    return this.session.currentUser as UserModel;
  }

  @action
  handleLogout(): void {
    this.session.handleLogout();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Popovers::SettingsMenu': typeof UiPopoverSettingsMenu;
  }
}
